export default "__VITE_ASSET__9nH1k45a__"